/**
 * Utilidades para estado visual completada/pendiente en filas de fichas (sheet).
 */
export function sheetNonEmpty(v) {
  return v != null && String(v).trim().length > 0;
}

export function sheetBoolAnswered(v) {
  return v === true || v === false;
}
